import React, { Component } from 'react'
import '../styles/FAQAnswer.css'


class FAQAnswer extends Component {

  render() {

    const arrowStyle = this.props.isToggled(this.props.id)
      ? "faq-answer-arrow faq-answer-arrow--down"
      : "faq-answer-arrow"

    return (
     <div className="faq-content-text" id={`faq-answer-${this.props.id}`}>
      <div
        className="faq-answer-header"
        id={`faq-answer-header-${this.props.id}`}
        onClick={(e) => this.props.handleClick(this.props.id)}
        >
        <h3>{this.props.title}</h3>
        <span className="faq-answer-arrow-circle">
          <span className={arrowStyle}></span>
        </span>
      </div>
      <div className={this.props.testOpen(this.props.id)}>
        {this.props.children}
      </div>
     </div>
    )
  }
}

export default FAQAnswer



// WEBPACK FOOTER //
// ./src/components/FAQAnswer.js